import React, { Fragment } from 'react';
import RefinementTag from './RefinementTag';

export type CheckboxFacetUIItem = {
  label: string;
  count: number;
  isRefined: boolean;
  value: string;
};

type CheckboxFacetUIProps = {
  facet: string;
  items: Array<CheckboxFacetUIItem>;
  checkboxItems: Array<CheckboxFacetUIItem>;
  checkedItems: Array<CheckboxFacetUIItem>;
  filterSearchTerm: string;
  showCheckboxInput: boolean;
  isSomeRefined: number;
  getTagLabel?: (label: string) => string;
  getItemLabel?: (label: string) => string;
  refineButtonRef: React.RefObject<HTMLButtonElement>;
  dropdownRef: React.RefObject<HTMLDivElement>;
  onToggleDropdown: (e: React.MouseEvent) => void;
  onFilterSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onToggleCheck: (e: React.ChangeEvent<HTMLInputElement>, item: CheckboxFacetUIItem) => void;
  onLabelClick: () => void;
  onRemoveTag: (e: React.SyntheticEvent, itemLabel: string) => void;
};

export const CheckboxFacetUI = ({
  facet,
  items,
  checkboxItems,
  checkedItems,
  filterSearchTerm,
  showCheckboxInput,
  isSomeRefined,
  getTagLabel = l => l,
  getItemLabel = l => l,
  refineButtonRef,
  dropdownRef,
  onToggleDropdown,
  onFilterSearchChange,
  onToggleCheck,
  onLabelClick,
  onRemoveTag,
}: CheckboxFacetUIProps) => {
  if (!filterSearchTerm && checkboxItems.length <= 0) {
    return <></>;
  }
  if (items.length <= 1) return null;

  return (
    <div className="search-results-facet">
      <button
        type="button"
        className={`search-results-facet-button${showCheckboxInput ? ' active' : ''}${
          isSomeRefined > 0 ? ' refined' : ''
        }`}
        ref={refineButtonRef}
        onClick={onToggleDropdown}
      >
        {facet}
        {isSomeRefined > 0 && ` (${isSomeRefined})`}
      </button>
      <div
        className={`search-results-facet-dropdown ais-RefinementList ${showCheckboxInput ? 'active' : ''}`}
        ref={dropdownRef}
      >
        {checkedItems.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {checkedItems.map((item, index) => {
              if (item.isRefined) {
                return (
                  <RefinementTag
                    key={index}
                    label={getTagLabel(item.label)}
                    handleTagRemoval={e => onRemoveTag(e, item.label)}
                  />
                );
              }
            })}
          </div>
        )}
        {items.length >= 10 && (
          <input
            type="text"
            className="filter-search"
            value={filterSearchTerm}
            onChange={onFilterSearchChange}
            placeholder="Search"
            autoComplete="true"
            autoCapitalize="none"
            style={!isSomeRefined ? { marginTop: '0.9375rem' } : undefined}
            autoFocus
          />
        )}
        <ul className="ais-RefinementList-list">
          {checkboxItems.length === 0 && <li style={{ padding: '20px', textAlign: 'center' }}>Nothing to refine!</li>}
          {checkboxItems.map((item, index) => (
            <li key={index} className="ais-RefinementList-item">
              <label className="ais-RefinementList-label">
                <input
                  className="ais-RefinementList-checkbox"
                  type="checkbox"
                  name={item.label}
                  value={item.value}
                  checked={checkedItems.some(i => i.label === item.label && i.isRefined)}
                  onChange={e => onToggleCheck(e, item)}
                />
                <span onClick={onLabelClick} className="ais-RefinementList-labelText">
                  <Fragment>{getItemLabel(item.label)}</Fragment>
                </span>
                <span className="ais-RefinementList-count">
                  <Fragment>{item.count}</Fragment>
                </span>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
